import { Flex, Icon, LinkBox, Text } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { MdPlayCircle } from "react-icons/md";
import LinkButton from "components/Shared/LinkButton";
import { APP_NAME } from "utils/config";
import { ONBOARDING_WALKTHROUGH_VIDEO_URL } from "utils/links";

export default function WalkthroughCard() {
  return (
    <LinkBox
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      mt={5}
      p={5}
      borderRadius="lg"
      background="magenta.veryDark"
      color="white"
    >
      <Flex alignItems="center" gap={4} minWidth={0}>
        <Flex
          alignItems="center"
          justifyContent="center"
          boxSize={12}
          borderRadius="full"
          background="whiteAlpha.200"
          flexShrink={0}
        >
          <Icon as={MdPlayCircle} boxSize={7} color="pink.300" />
        </Flex>

        <Flex direction="column" minWidth={0}>
          <Text fontWeight="700">New to {APP_NAME}?</Text>
          <Text fontSize="sm" color="whiteAlpha.800">
            Watch a 2-minute walkthrough of the workspace.
          </Text>
        </Flex>
      </Flex>

      <LinkButton
        colorScheme="pinkButton"
        rightIcon={<ExternalLinkIcon />}
        size="xs"
        isExternal
        isLinkOverlay
        position="static"
        href={ONBOARDING_WALKTHROUGH_VIDEO_URL}
      >
        Watch Video
      </LinkButton>
    </LinkBox>
  );
}
